import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["name", "defaultChecked"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { forwardRef } from "react";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconCheck = function IconCheck(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(-17.529 -22.087)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M18.674,33.177,27.1,43.116l18.862-20",
        fill: "none",
        stroke: "#eb7d3c",
        strokeWidth: "3"
      })
    })
  }));
};
IconCheck.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29.523",
  height: "23.278",
  viewBox: "0 0 29.523 23.278"
};
const MetaSelectorField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      name,
      defaultChecked
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx("div", {
    className: styles.metaSelectorField,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.metaSelector,
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        id: `checkbox-${name}`,
        name: name,
        type: "checkbox",
        defaultChecked: defaultChecked
      }, _props)), /*#__PURE__*/_jsx("label", {
        htmlFor: `checkbox-${name}`,
        className: styles.label,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(IconCheck, {})
        })
      })]
    })
  });
});
MetaSelectorField.displayName = "MetaSelectorField";
export default MetaSelectorField;